document.addEventListener("ra_translate_bar_loaded", function () {
	window.dataLayer = window.dataLayer || [];

	// custom events: we dispatch them here as well, as we can assume gtm will be tracking most
	// actions we want to run on page, and we _know_ the bar as loaded from how this is invoked
	const translationRun = new Event("ra_translate_bar_used");

	// listens for the bar being opened
	const translateBar = document.getElementsByClassName('goog-te-gadget-simple')[0];
	translateBar.addEventListener('click', function () {
		window.dataLayer.push({
			event: 'translateBar.opened',
		});
	}, {once: true})

	// listens for the menu being used
	// we watch the html element of the page, where google adds a 'translated-*' class when the
	// translation is run
	const docElement = document.documentElement;
	const observer = new MutationObserver((mutations) => {
		for (const m of mutations) {
			if (m.attributeName === 'class') {
				if (docElement.classList.contains('translated-ltr') || docElement.classList.contains('translated-rtl')) {
					window.dataLayer.push({
						event: 'translateBar.used',
						language: docElement.lang
					});
					document.dispatchEvent(translationRun);
				} else {
					window.dataLayer.push({
						event: 'translateBar.reverted'
					})
				}
			}
		}
	});
	observer.observe(docElement, { attributes: true, attributeFilter: ['class'] });

	// listens for clicks on the translation policy
	const policyLink = document.getElementsByClassName('auto-translate-bar-policy')[0];
	policyLink.addEventListener('click', function () {
		window.dataLayer.push({
			event: 'translateBar.policyPageOpened',
		})
	}, {once: true})
})
